import { LaunchpadId, launchpadDefinitions } from '@/constants/launchpads';

// Current 0x sources and historical providers found in trade history.
// Use lowercase family keys where possible: "uniswap" covers Uniswap_V3 and UniswapV3.
export const liquidityProviderLogos = {
  '0x': '/images/liquidity-providers/0x.png',
  'aave': '/images/liquidity-providers/aave.png',
  'aborean': '/images/liquidity-providers/aborean.png',
  'acryptos': '/images/liquidity-providers/acryptos.png',
  'aerodrome': '/images/liquidity-providers/aerodrome.png',
  'agni': '/images/liquidity-providers/agni.png',
  'alandale': '/images/liquidity-providers/alandale.webp',
  'alienbase': '/images/liquidity-providers/alienbase.png',
  'ambient': '/images/liquidity-providers/ambient.png',
  'apeswap': '/images/liquidity-providers/apeswap.png',
  // SyncSwap's Aqua pools have a separate 0x source name.
  'aqua': '/images/liquidity-providers/syncswap.png',
  'atlantis': '/images/liquidity-providers/atlantis.png',
  'babydogeswap': '/images/liquidity-providers/babydogeswap.png',
  'bags': launchpadDefinitions[LaunchpadId.BAGS].logo,
  'bakeryswap': '/images/liquidity-providers/bakeryswap.png',
  'balancer': '/images/liquidity-providers/balancer.png',
  'bancor': '/images/liquidity-providers/bancor.png',
  'baseline': '/images/liquidity-providers/baseline.png',
  'baseswap': '/images/liquidity-providers/baseswap.png',
  'basex': '/images/liquidity-providers/basex.png',
  'beanexchange': '/images/liquidity-providers/beanexchange.png',
  'bebop': '/images/liquidity-providers/bebop.png',
  'beethovenx': '/images/liquidity-providers/beethovenx.png',
  'biswap': '/images/liquidity-providers/biswap.png',
  'blackhole': '/images/liquidity-providers/blackhole.webp',
  'bladeswap': '/images/liquidity-providers/bladeswap.png',
  'blaster': '/images/liquidity-providers/blaster.png',
  'brownfi': '/images/liquidity-providers/brownfi.webp',
  'butter_swap': '/images/liquidity-providers/butterswap.png',
  'camelot': '/images/liquidity-providers/camelot.png',
  'capricorn': '/images/liquidity-providers/capricorn.webp',
  'cleo': '/images/liquidity-providers/cleo.png',
  'clober': '/images/liquidity-providers/clober.png',
  'compound': '/images/liquidity-providers/compound.png',
  'crust': '/images/liquidity-providers/crust.png',
  'cryptocom': '/images/liquidity-providers/cryptocom.png',
  'curve': '/images/liquidity-providers/curve.png',
  'cyberblast': '/images/liquidity-providers/cyberblast.png',
  'dackieswap': '/images/liquidity-providers/dackieswap.png',
  'defi_swap': '/images/liquidity-providers/defiswap.png',
  'dfyn': '/images/liquidity-providers/dfyn.png',
  'dodo': '/images/liquidity-providers/dodo.png',
  'dyorswap': '/images/liquidity-providers/dyorswap.webp',
  'dyson': '/images/liquidity-providers/dyson.png',
  'echodex': '/images/liquidity-providers/echodex.png',
  'ekubo': '/images/liquidity-providers/ekubo.png',
  'elfomofi': '/images/liquidity-providers/elfomofi.webp',
  'ellipsis': '/images/liquidity-providers/ellipsis.png',
  'equalizer': '/images/liquidity-providers/equalizer.png',
  'etherex': '/images/liquidity-providers/etherex.webp',
  'faze': launchpadDefinitions[LaunchpadId.FAZE].logo,
  'fenix': '/images/liquidity-providers/fenixcl.png',
  // Fermi is operated by IMC; use its operator mark.
  'fermi': '/images/liquidity-providers/fermi.webp',
  'firebirdoneswap': '/images/liquidity-providers/firebirdoneswap.png',
  'flap': launchpadDefinitions[LaunchpadId.FLAP].logo,
  'fluid': '/images/liquidity-providers/fluid.png',
  'fluidlite': '/images/liquidity-providers/fluid.png',
  'fourmeme': launchpadDefinitions[LaunchpadId.FOUR_MEME].logo,
  'fraxswap': '/images/liquidity-providers/fraxswap.png',
  'fusionx': '/images/liquidity-providers/fusionx.png',
  'giga': '/images/liquidity-providers/giga.webp',
  'gmx': '/images/liquidity-providers/gmx.png',
  'hanji': '/images/liquidity-providers/hanji.webp',
  'hybra': '/images/liquidity-providers/hybra.png',
  'hydrex': '/images/liquidity-providers/hydrex.webp',
  'hyperswap': '/images/liquidity-providers/hyperswap.png',
  'infusion': '/images/liquidity-providers/infusion.png',
  'inkyswap': '/images/liquidity-providers/inkyswap.webp',
  'integral': '/images/liquidity-providers/integral.png',
  'ironswap': '/images/liquidity-providers/ironswap.png',
  'iziswap': '/images/liquidity-providers/iziswap.png',
  'jetswap': '/images/liquidity-providers/jetswap.png',
  'kim': '/images/liquidity-providers/kim.png',
  'kinetix': '/images/liquidity-providers/kinetix.png',
  'kipseli': '/images/liquidity-providers/kipseli.webp',
  'kittenswap': '/images/liquidity-providers/kittenswap.png',
  'knightswap': '/images/liquidity-providers/knightswap.png',
  'kona': '/images/liquidity-providers/kona.png',
  'ktx.finance': '/images/liquidity-providers/ktx.png',
  'kuru': '/images/liquidity-providers/kuru.png',
  'kyberdmm': '/images/liquidity-providers/kyberswap.png',
  'lido': '/images/liquidity-providers/lido.png',
  'liquidcore': '/images/liquidity-providers/liquidcore.webp',
  'lista': '/images/liquidity-providers/lista.webp',
  'lithos': '/images/liquidity-providers/lithos.webp',
  'lunarbase': '/images/liquidity-providers/lunarbase.webp',
  'lynex': '/images/liquidity-providers/lynex.png',
  'maker_psm': '/images/liquidity-providers/maker.png',
  'maverick': '/images/liquidity-providers/maverick.png',
  'mdex': '/images/liquidity-providers/mdex.png',
  'merchantmoe': '/images/liquidity-providers/merchantmoe.png',
  'meshswap': '/images/liquidity-providers/meshswap.png',
  'metavault': '/images/liquidity-providers/metavault.png',
  'methlab_swap': '/images/liquidity-providers/methlabswap.png',
  'metric': '/images/liquidity-providers/metric.png',
  'mimswap': '/images/liquidity-providers/mimswap.png',
  'mobiusmoney': '/images/liquidity-providers/mobiusmoney.png',
  'mondaytrade': '/images/liquidity-providers/mondaytrade.png',
  'monoswap': '/images/liquidity-providers/monoswap.png',
  'morpheusswap': '/images/liquidity-providers/morpheusswap.png',
  'morphex': '/images/liquidity-providers/morphex.png',
  'mstable': '/images/liquidity-providers/mstable.png',
  'nabla': '/images/liquidity-providers/nabla.png',
  'naddotfun': launchpadDefinitions[LaunchpadId.NAD_FUN].logo,
  'native': '/images/liquidity-providers/native.png',
  'nerve': '/images/liquidity-providers/nerve.png',
  'nest': '/images/liquidity-providers/nest.png',
  'nile': '/images/liquidity-providers/nile.png',
  'nuri_cl': '/images/liquidity-providers/nuri.png',
  'octoswap': '/images/liquidity-providers/octoswap.png',
  'orcawhirlpools': '/images/liquidity-providers/orca.png',
  'origin': '/images/liquidity-providers/origin.png',
  'orion': '/images/liquidity-providers/orion.png',
  'orvex': '/images/liquidity-providers/orvex.webp',
  'overnight': '/images/liquidity-providers/overnight.png',
  'pancakeswap': '/images/liquidity-providers/pancakeswap.png',
  'pangolin': '/images/liquidity-providers/pangolin.png',
  'peach': launchpadDefinitions[LaunchpadId.PEACH].logo,
  'pharaoh': '/images/liquidity-providers/pharaoh.png',
  'platypus': '/images/liquidity-providers/platypus.png',
  'pons': launchpadDefinitions[LaunchpadId.PONS].logo,
  'printr': launchpadDefinitions[LaunchpadId.PRINTR].logo,
  'project_x': '/images/liquidity-providers/prjx.png',
  'pumpfun': launchpadDefinitions[LaunchpadId.PUMP_FUN].logo,
  'pumpswap': launchpadDefinitions[LaunchpadId.PUMP_FUN].logo,
  'purps': '/images/liquidity-providers/purps.png',
  'quickswap': '/images/liquidity-providers/quickswap.png',
  'ramses': '/images/liquidity-providers/ramses.png',
  'raydiumamm': '/images/liquidity-providers/raydium.png',
  'raydiumclmm': '/images/liquidity-providers/raydium.png',
  'raydiumcpmm': '/images/liquidity-providers/raydium.png',
  'reservoir': '/images/liquidity-providers/reservoir.webp',
  'retro': '/images/liquidity-providers/retro.png',
  'ringswap': '/images/liquidity-providers/ringswap.png',
  'rocketpool': '/images/liquidity-providers/rocketpool.png',
  'rubicon': '/images/liquidity-providers/rubicon.png',
  'saddle': '/images/liquidity-providers/saddle.png',
  'secta': '/images/liquidity-providers/secta.png',
  'sectorone': '/images/liquidity-providers/sectorone.webp',
  'shibaswap': '/images/liquidity-providers/shibaswap.png',
  'sky_migration': '/images/liquidity-providers/skymigration.png',
  'skydrome': '/images/liquidity-providers/skydrome.png',
  'solfi': '/images/liquidity-providers/solfi.png',
  'solidly': '/images/liquidity-providers/solidly.png',
  'soswap': '/images/liquidity-providers/soswap.png',
  'spark': '/images/liquidity-providers/spark.png',
  'spartadex': '/images/liquidity-providers/spartadex.png',
  'spiritswap': '/images/liquidity-providers/spiritswap.png',
  'spookyswap': '/images/liquidity-providers/spookyswap.png',
  'squadswap': '/images/liquidity-providers/squadswap.png',
  'stabblestableswap': '/images/liquidity-providers/stabble.png',
  'stabbleweightedswap': '/images/liquidity-providers/stabble.png',
  'stepn': '/images/liquidity-providers/stepn.png',
  'stratum_exchange': '/images/liquidity-providers/stratumexchange.png',
  'supswap': '/images/liquidity-providers/supswap.png',
  'sushiswap': launchpadDefinitions[LaunchpadId.SUSHISWAP].logo,
  'swapbased': '/images/liquidity-providers/swapbased.png',
  'swapblast': '/images/liquidity-providers/swapblast.png',
  'swapmode': '/images/liquidity-providers/swapmode.png',
  'swapsicle': '/images/liquidity-providers/swapsicle.png',
  'synapse': '/images/liquidity-providers/synapse.png',
  'syncswap': '/images/liquidity-providers/syncswap.png',
  'synthswap': '/images/liquidity-providers/synthswap.png',
  'tesseraswap': '/images/liquidity-providers/tesseraswap.png',
  'thena': '/images/liquidity-providers/thena.png',
  'thruster': '/images/liquidity-providers/thruster.png',
  'tokan': '/images/liquidity-providers/tokan.png',
  'topaz': '/images/liquidity-providers/topaz.webp',
  'traderjoe': '/images/liquidity-providers/traderjoe.png',
  'ubeswap': '/images/liquidity-providers/ubeswap.png',
  'ultrasolid': '/images/liquidity-providers/ultrasolid.png',
  'uniswap': launchpadDefinitions[LaunchpadId.UNISWAP_AUCTIONS].logo,
  'up': '/images/liquidity-providers/up.webp',
  'velodrome': '/images/liquidity-providers/velodrome.png',
  'virtuals': launchpadDefinitions[LaunchpadId.VIRTUAL].logo,
  'waultswap': '/images/liquidity-providers/waultswap.png',
  'wombat': '/images/liquidity-providers/wombat.png',
  'woofi': '/images/liquidity-providers/woofi.png',
  'wrapped_mlt': '/images/liquidity-providers/wmlt.png',
  'xfai': '/images/liquidity-providers/xfai.png',
  'yearn': '/images/liquidity-providers/yearn.png',
  'yoshi': '/images/liquidity-providers/yoshi.png',
  'z_protocol': '/images/liquidity-providers/zprotocol.png',
  'zebra': '/images/liquidity-providers/zebra.png',
} as const;

// Historical identifiers that need an explicit alias after normalization and prefix matching.
// For example, MakerPsm does not match the 0x family key "maker_psm".
export const tradeHistoryMappings = {
  apeswapfinance: liquidityProviderLogos.apeswap,
  kyberelastic: liquidityProviderLogos.kyberdmm,
  makerpsm: liquidityProviderLogos.maker_psm,
} as const;

// Jupiter route labels from /swap/v1/program-id-to-label.
// Keep shared providers here too so quote logos do not depend on CoinGecko mappings.
export const jupiterMappings = {
  '1dex': '/images/liquidity-providers/1dex.png',
  'aldrin': '/images/liquidity-providers/aldrin.png',
  'bonkswap': '/images/liquidity-providers/bonkswap.png',
  'crema': '/images/liquidity-providers/crema.png',
  'cropper': '/images/liquidity-providers/cropper.png',
  'dexlab': '/images/liquidity-providers/dexlab.png',
  'fluxbeam': '/images/liquidity-providers/fluxbeam.png',
  'guacswap': '/images/liquidity-providers/guacswap.png',
  'helium_network': '/images/liquidity-providers/heliumnetwork.png',
  'invariant': '/images/liquidity-providers/invariant.png',
  'mercurial': '/images/liquidity-providers/mercurial.png',
  'meteora': launchpadDefinitions[LaunchpadId.METEORA_DBC].logo,
  'obric': '/images/liquidity-providers/obric.png',
  'openbook': '/images/liquidity-providers/openbook.png',
  'orca': liquidityProviderLogos.orcawhirlpools,
  'penguin': '/images/liquidity-providers/penguin.png',
  'perena': '/images/liquidity-providers/perena.png',
  'perps': '/images/liquidity-providers/perps.png',
  'phoenix': '/images/liquidity-providers/phoenix.png',
  'pump.fun': liquidityProviderLogos.pumpfun,
  'raydium': liquidityProviderLogos.raydiumamm,
  'raydium_launchlab': launchpadDefinitions[LaunchpadId.LAUNCHLAB].logo,
  'saber': '/images/liquidity-providers/saber.png',
  'sanctum': '/images/liquidity-providers/sanctum.png',
  'saros': '/images/liquidity-providers/saros.png',
  'solayer': '/images/liquidity-providers/solayer.png',
  'stabble_stable_swap': liquidityProviderLogos.stabblestableswap,
  'stabble_weighted_swap': liquidityProviderLogos.stabbleweightedswap,
  // The 0x Solana quote adapter also uses Jupiter's Whirlpool label.
  'whirlpool': liquidityProviderLogos.orcawhirlpools,
} as const;

// CoinGecko DEX IDs from token pools: aliases, additional providers and specific logo overrides.
// Normalize keys to lowercase with underscores, e.g. "raydium-launchlab" → "raydium_launchlab".
export const coinGeckoMappings = {
  alien_base: liquidityProviderLogos.alienbase,
  argus: launchpadDefinitions[LaunchpadId.ARGUS].logo,
  bankr: launchpadDefinitions[LaunchpadId.BANKR].logo,
  beethoven_x: liquidityProviderLogos.beethovenx,
  clanker: launchpadDefinitions[LaunchpadId.CLANKER].logo,
  daos_fun: '/images/liquidity-providers/daosfun.png',
  dexlab: '/images/liquidity-providers/dexlab.png',
  fluxbeam: '/images/liquidity-providers/fluxbeam.png',
  four_meme: liquidityProviderLogos.fourmeme,
  kyberswap: liquidityProviderLogos.kyberdmm,
  merchant_moe: liquidityProviderLogos.merchantmoe,
  meteora: launchpadDefinitions[LaunchpadId.METEORA_DBC].logo,
  moonshot: launchpadDefinitions[LaunchpadId.MOONSHOT].logo,
  nuri: liquidityProviderLogos.nuri_cl,
  o1_launchpad: launchpadDefinitions[LaunchpadId.O1_EXCHANGE].logo,
  orca: liquidityProviderLogos.orcawhirlpools,
  pump_fun: liquidityProviderLogos.pumpfun,
  raydium: liquidityProviderLogos.raydiumamm,
  raydium_launchlab: launchpadDefinitions[LaunchpadId.LAUNCHLAB].logo,
  saros: '/images/liquidity-providers/saros.png',
  token_mill: '/images/liquidity-providers/tokenmill.png',
  uniswap_pools_trade: launchpadDefinitions[LaunchpadId.POOLS_TRADE].logo,
  zora: launchpadDefinitions[LaunchpadId.ZORA].logo,
} as const;

const logosByName = new Map<string, string>(
  Object.entries({
    ...coinGeckoMappings,
    ...tradeHistoryMappings,
    ...jupiterMappings,
    ...liquidityProviderLogos,
  }),
);

// Prefer specific prefixes such as "uniswap_pools_trade" over "uniswap".
const logoPrefixes = [...logosByName.entries()].sort(([a], [b]) => b.length - a.length);

const normalizeName = (name: string) =>
  name.trim().replaceAll(' ', '_').replaceAll('-', '_').toLowerCase();

export const getLiquidityProviderLogoSrc = (name: string): string | undefined => {
  // Keep the fallback for trade-history fields containing multiple comma-separated providers.
  if (name.includes(',')) return undefined;

  const normalizedName = normalizeName(name);

  // Try exact names, then "provider_" prefixes, then "providerv" prefixes.
  return (
    logosByName.get(normalizedName) ??
    logoPrefixes.find(([provider]) => normalizedName.startsWith(`${provider}_`))?.[1] ??
    logoPrefixes.find(([provider]) => normalizedName.startsWith(`${provider}v`))?.[1]
  );
};
